var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":{ name: _vm.routeName }}},[_vm._v(" "+_vm._s(_vm.routeName.replaceAll('-', ' '))+" "),_c('i',{staticClass:"mdi mdi-plus mr-1"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }